import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="page-container">
      <h1>Terms & Conditions</h1>
      <p>
        Welcome to our website. By accessing or using our services, you agree to
        comply with the following terms and conditions. Please read them
        carefully.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing this website, you acknowledge that you have read,
        understood, and agree to be bound by these terms.
      </p>

      <h2>2. Use of Services</h2>
      <p>
        You agree not to misuse our services or use them for unlawful purposes.
        Any violation may result in termination of access.
      </p>

      <h2>3. Intellectual Property</h2>
      <p>
        All content, design, and materials on this website are owned by us or
        licensed to us. Unauthorized use is prohibited.
      </p>

      <h2>4. Limitation of Liability</h2>
      <p>
        We are not liable for any damages arising from the use of our website or
        services.
      </p>

      <h2>5. Governing Law</h2>
      <p>
        These terms are governed by the laws of India, and any disputes shall be
        subject to the jurisdiction of courts in Madhya Pradesh.
      </p>
    </div>
  );
};

export default TermsAndConditions;
